class Wysiwyg {
    constructor() {
        const wys = document.querySelectorAll('.wysiwyg');
        wys.forEach((wy) => {
            const tables = wy.querySelectorAll('table');
            tables.forEach((table) => {
                // Tạo thẻ div mới
                const wrapper = document.createElement('div');
                wrapper.classList.add('table-wrapper'); // Thêm class nếu cần

                // Đặt table vào bên trong div
                table.parentNode.insertBefore(wrapper, table);
                wrapper.appendChild(table);
            });
        });

        document.querySelectorAll('p')
            .forEach(p => {
                if (p.innerHTML.trim() === '&nbsp;' || p.textContent.trim() === '\u00A0') {
                    p.classList.add('clear');
                }
            });
    }
}

export default Wysiwyg;
